import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaGraduationCap, FaBook, FaMedal, FaStar, FaLayerGroup, FaUserTie, FaRocket, FaHandshake } from 'react-icons/fa';
import StatCard from '../../components/StatCard';
import './Stats.css';
import { apiFetch } from '../../utils/api';

const Stats = ({ onPopularCoursesClick }) => {
  const [stats, setStats] = useState({
    total_active_courses: 0,
    total_departments: 0,
    total_certificates: 0,
    total_users: 0,
    total_featured_courses: 0,
    total_enrolled_courses: 0
  });
  const [aiFirstInitiativeCount, setAiFirstInitiativeCount] = useState(0);
  const [softSkillsCount, setSoftSkillsCount] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllStats = async () => {
      try {
        const email = localStorage.getItem('userEmail');

        // Use Promise.all to fetch all stats simultaneously
        const promises = [
          // Fetch general stats
          apiFetch(email
            ? `${window._env_.API_BASE_URL}/dashboard/summary?email=${encodeURIComponent(email)}`
            : `${window._env_.API_BASE_URL}/dashboard/summary`
          ),
          // Fetch BTG courses
          apiFetch(`${window._env_.API_BASE_URL}/courses/summary`),
          // Fetch BTG training videos
          apiFetch(`${window._env_.API_BASE_URL}/training-videos/?department_name=${encodeURIComponent('Business Technology Group')}&active_only=true`),
          // Fetch Others department training videos
          apiFetch(`${window._env_.API_BASE_URL}/training-videos/?department_name=${encodeURIComponent('Others')}&active_only=true`)
        ];

        const [generalStats, coursesData, trainingVideosData, othersTrainingVideosData] = await Promise.all(promises);

        // Set general stats
        setStats({
          total_active_courses: generalStats.total_active_courses ?? 0,
          total_departments: generalStats.total_departments ?? 0,
          total_certificates: generalStats.total_certificates ?? 0,
          total_users: generalStats.total_users ?? 0,
          total_featured_courses: generalStats.total_featured_courses ?? 0,
          total_enrolled_courses: generalStats.total_enrolled_courses ?? 0,
        });

        // Calculate AI-First Initiative count (BTG courses + BTG training videos)
        const btgCourses = coursesData.filter(course =>
          course.department_name === 'Business Technology Group'
        );
        const btgTrainingVideos = trainingVideosData || [];
        const totalAiFirstCount = btgCourses.length + btgTrainingVideos.length;

        setAiFirstInitiativeCount(totalAiFirstCount);

        // Calculate Soft Skills count (Others department courses + Others training videos)
        const othersCourses = coursesData.filter(course =>
          course.department_name === 'Soft Skills'
        );
        const othersTrainingVideos = othersTrainingVideosData || [];
        const totalSoftSkillsCount = othersCourses.length + othersTrainingVideos.length;

        setSoftSkillsCount(totalSoftSkillsCount);

      } catch (error) {
        console.error('Error fetching stats:', error);
        setError('Failed to load statistics. Please try again later.');
      }
    };

    fetchAllStats();
  }, []);

  if (error) {
    return <div className="stats-error">Error: {error}</div>;
  }

  return (
    <div className="stats">
      <div className="stats-container">          {/* ← ADD THIS WRAPPER */}
        <Link to="/departments">
          <StatCard icon={FaBook} title="Total Courses" count={stats.total_active_courses} className="total-courses" />
        </Link>
        <Link to="/departments">
          <StatCard icon={FaGraduationCap} title="Departments" count={stats.total_departments} className="departments" />
        </Link>
        {/* <div onClick={onPopularCoursesClick} role="button" tabIndex={0} style={{cursor:'pointer'}}
             onKeyPress={e => (e.key==='Enter'||e.key===' ') && onPopularCoursesClick()}>
          <StatCard icon={FaStar} title="Popular Courses" count={stats.total_featured_courses} className="popular-courses" />
        </div> */}
        <Link to="/certificates">
          <StatCard icon={FaMedal} title="My Certificates" count={stats.total_certificates} className="my-certificates" />
        </Link>
        <Link to="/my-courses">
          <StatCard icon={FaLayerGroup} title="My Courses" count={stats.total_enrolled_courses} className="mycourses" />
        </Link>
        <Link to="/departments/Business%20Technology%20Group">
          <StatCard icon={FaRocket} title="AI-First Initiative" count={aiFirstInitiativeCount} className="ai-first" />
        </Link>
        <Link to="/departments/Soft Skills">
          <StatCard icon={FaHandshake} title="Soft Skills" count={softSkillsCount} className="soft-skills" />
        </Link>
      </div>
    </div>
  );
};

export default Stats;